import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from '../pages/Authentication/Login';
import Error404 from '../pages/Errors/Error404';
import UserInfo from '../components/UserInfo';
import UserList from '../components/UserList';
// import Users from '../components/Users';
import PrivateRoutes from './PrivateRoutes';
import Logout from '../pages/Authentication/Logout';
import Doctor from '../pages/Doctor/Doctor';
import Center from '../pages/Center/Center';
import Operator from '../pages/Operator/Operator';
import Xray from '../pages/XrayType/XrayType';
import ManagePages from '../pages/ManagePages/ManagePages';
import Slider from '../pages/Slider/Slider';
import SocialMediaLinks from '../pages/SocialMediaLinks/SocialMediaLinks';
import Gallery from '../pages/Gallery/Gallery';
import ContactUs from '../pages/ContactUs/ContactUs';
import XrayMachine from '../pages/XrayMachine/XrayMachine';
import Home from '../testiGo/pages/Home';
import About from '../testiGo/pages/About';
import OurTeam from '../pages/OurTeam/OurTeam';
import WebRoutes from './WebRoute';
import ManagePagesContent from '../pages/ManagePagesContent/ManagePagesContent'
import Services from '../testiGo/pages/Services';
import Contact from '../testiGo/pages/Contact';
import DynamicPages from '../testiGo/pages/DynamicPages';
import ManageDynamicPages from '../pages/ManageDynamicPages/ManageDynamicPages';
import XrayBooking from '../pages/XrayBooking/XrayBooking';
import Faq from '../pages/Faq/Faq';
import ViewBookingDetail from '../components/XrayBookings/ViewBookingDetail';
import XrayInveBooking from '../pages/XrayInveReport/XrayInveBooking';
import Transactions from '../pages/Transactions/Transactions';
import Dashboard from '../pages/Dashboard/Dashboard';
import UserBookingList from '../components/User/UserXrayBookingsList';
import BookingDetail from '../components/User/BookingDetail';
import UserInfoPage from '../pages/User/UserInfoPage';
import Configuration from '../pages/Configuration/Configuration';
const AppRoute = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateRoutes />}>
          {/* <Route path='/' element={<Users/>} />
                  <Route path='/products' element={<Products/>} /> */}
          <Route path='users' element={<UserList />} />
          <Route path='userinfo' element={<UserInfo />} />
          <Route path='doctor' element={<Doctor />} />
          <Route path='center' element={<Center />} />
          <Route path='operator' element={<Operator />} />
          <Route path='xray' element={<Xray />} />
          <Route path='xray-machine' element={<XrayMachine />} />
          <Route path='manage-pages' element={<ManagePages />} />
          <Route path='slider' element={<Slider />} />
          <Route path='social-media-links' element={<SocialMediaLinks />} />
          <Route path='gallery' element={<Gallery />} />
          <Route path='contact-us' element={<ContactUs />} />
          <Route path='logout' element={<Logout />} />
          <Route path='testing' element={<UserInfo />} />
          <Route path='our-team' element={<OurTeam />} />
          <Route path='manage-pages-content' element={<ManagePagesContent />} />
          <Route path='manage-dynamic-pages' element={<ManageDynamicPages />} />
          <Route path='xray-booking' element={<XrayBooking />} />
          <Route path='faq' element={<Faq />} />
          <Route path='view-booking-detail/:id' element={<ViewBookingDetail />} />
          <Route path='xray-investigation-report' element={<XrayInveBooking />} />
          <Route path='transactions' element={<Transactions />} />
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='user-info/:id' element={<UserInfoPage />} />
          <Route path='user/bookings/:id' element={<UserBookingList />} />
          <Route path='user/bookings/detail/:id' element={<BookingDetail />} />
          <Route path='configuration' element={<Configuration />} />
        </Route>
        <Route path='/' element={<WebRoutes />}>
          <Route index element={<Home />} />
          <Route path='home' element={<Home />} />
          <Route path='about' element={<About />} />
          <Route path='services' element={<Services />} />
          <Route path='contact' element={<Contact />} />
          <Route path='page/:url' element={<DynamicPages />} />
        </Route>
        <Route path='testigo' element={<WebRoutes />}>
          <Route path='home' element={<Home />} />
          <Route path='about' element={<About />} />
          <Route path='services' element={<Services />} />
          <Route path='contact' element={<Contact />} />
          <Route path='page/:url' element={<DynamicPages />} />
        </Route>
        <Route path='/login' element={<Login />} />
        <Route path="*" element={<Error404 />} />

      </Routes>
    </Router>
  );
}
export default AppRoute;
